export default __webpack_public_path__ + "static/media/1.f3dda0e6.png";